module.exports = __webpack_public_path__ + "img/ListaDeClientes-admin.9cc041cf.svg";